import { Text } from '@crossfit/design-system'
import style from './style.module.scss'
import { Button, Icon } from '@crossfit/ui'
import Close from './close.svg'
import classNames from 'classnames'
import { useIsLaptopOrAbove, useIsMobile } from 'hooks/useMediaQuery'

export type CollapsibleBannerProps = {
  type: 'urgent' | 'nonurgent'
  linkText: string
  linkUrl: string
  title: string
  description: string
  dismiss?: () => void
}

export default function CollapsibleBanner({
  type,
  linkText,
  linkUrl,
  title,
  description,
  dismiss,
}: CollapsibleBannerProps) {
  const isLaptop = useIsLaptopOrAbove()

  return (
    <div
      className={classNames(
        style.wrapper,
        type === 'urgent' && style.urgent,
        type === 'nonurgent' && style.nonUrgent,
      )}
    >
      <div className={style.contentContainer}>
        <div className={style.headerContainer}>
          {type === 'nonurgent' && (
            <Icon name='info' className={style.headerIcon} />
          )}
          <Text type='body' size='md' className={style.header} bold>
            {title}
          </Text>
        </div>
        <Text
          type='body'
          size='sm'
          dangerousHTML={description}
          className={style.description}
        />
      </div>
      {!isLaptop && type !== 'urgent' && (
        <button className={style.closeButton} onClick={dismiss}>
          <img src={Close} />
        </button>
      )}
      <div className={style.buttonContainer}>
        <Button
          variant='secondary'
          rightIcon={<Icon name='arrow-right' />}
          className={style.actionButton}
          onClick={() => (location.href = linkUrl)}
        >
          {linkText}
        </Button>
        {isLaptop && type !== 'urgent' && (
          <Button variant='tertiary' onClick={dismiss}>
            DIMISS
          </Button>
        )}
      </div>
    </div>
  )
}
